/*
  km-angebot.js · Kirchberger Metall · 10.09.2026
  Angebotsanfrage auf Standardprodukten: Modal öffnen, Adresse aufnehmen, an n8n schicken.

  Abgeleitet aus km-konfigurator-anfrage.js. Unterschied: statt der Konfiguration gehen
  Varianten-ID und Menge mit. Beide liest das Skript beim Klick aus dem Theme-Formular
  (Focal: input[name="id"] im Kaufformular, input[name="quantity"] im Mengenwähler).
  Der angezeigte Preis wird NICHT mitgeschickt: n8n holt ihn serverseitig aus Shopify.

  14.10.2026 (Martin): Gibt es die gewaehlte Kombination nicht als Variante (Luecke in der Matrix,
  z. B. Vordach Kristall 2000 x 1025 mm), setzt Focal das Feld "id" leer bzw. auf "undefined".
  Dann geht die Anfrage ohne Varianten-ID, aber mit den gewaehlten Optionen an n8n, n8n macht daraus
  eine Anfrage an Martin. Kein Rueckfall auf die Startvariante: das waere ein Angebot fuer die falsche Ausfuehrung.
*/
(function () {
  function init(root) {
    var sid = root.getAttribute('data-section-id');
    var knopf = document.getElementById('km-ang-quote-' + sid);
    var modal = document.getElementById('km-ang-modal-' + sid);
    var anfrage = document.getElementById('km-ang-quoteform-' + sid);
    if (!knopf || !modal || !anfrage) return;

    var ctxEl = document.getElementById('km-ang-ctx-' + sid);
    var varEl = document.getElementById('km-ang-varianten-' + sid);
    if (!ctxEl) return;
    var CTX = JSON.parse(ctxEl.textContent);
    var VARIANTEN = {};
    try { VARIANTEN = varEl ? JSON.parse(varEl.textContent) : {}; } catch (e) { VARIANTEN = {}; }

    var zusammenfassung = document.getElementById('km-ang-modal-konfig-' + sid);
    var hinweis = document.getElementById('km-ang-msg-' + sid);
    var fehlerfeld = document.getElementById('km-ang-quoteerr-' + sid);
    var fertig = document.getElementById('km-ang-quotedone-' + sid);
    var lieferBlock = document.getElementById('km-ang-liefer-' + sid);

    var lead = modal.querySelector('.km-modal__lead');
    var leadText = lead ? lead.textContent : '';
    var fertigTitel = fertig ? fertig.querySelector('.km-modal__done-titel') : null;
    var fertigText = fertig ? fertig.querySelector('p') : null;
    var fertigTitel0 = fertigTitel ? fertigTitel.textContent : '';
    var fertigText0 = fertigText ? fertigText.textContent : '';

    var geoeffnetUm = 0;
    var zuletztFokussiert = null;
    var laeuft = false;

    var geld = null;
    try {
      geld = new Intl.NumberFormat('de-DE', { style: 'currency', currency: CTX.currency || 'EUR' });
    } catch (e) { geld = null; }

    function esc(t) {
      return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
    }

    // Kaufformular des Themes: das Feld name="id" trägt die gewählte Variante,
    // der Mengenwähler hängt per form-Attribut daran.
    function kaufformular() {
      var f = document.querySelector('form[id^="product-form-main-' + CTX.productId + '"]');
      if (!f) f = document.querySelector('.product-form__buy-buttons form');
      return f;
    }
    function varianteId() {
      var f = kaufformular();
      var feld = f ? f.querySelector('input[name="id"]') : null;
      var fid = f ? f.getAttribute('id') : '';
      if (!feld && fid) feld = document.querySelector('[name="id"][form="' + fid + '"]');
      var id = feld ? String(feld.value || '') : String(CTX.variantId || '');
      return /^\d+$/.test(id) ? id : '';
    }
    // Gewaehlte Optionen (Focal: versteckte Felder option1..3 am Kaufformular, Wert = ID des
    // Optionswerts, Beschriftung im Auswahlknopf). Nur fuer Anfragen ohne passende Variante.
    function optionen() {
      var f = kaufformular();
      // getAttribute statt f.id: das Formular hat ein Feld name="id", f.id liefert dieses Feld.
      var fid = f ? f.getAttribute('id') : '';
      if (!fid) return [];
      var aus = [];
      document.querySelectorAll('[name^="option"][form="' + fid + '"]').forEach(function (el) {
        if (!/^option\d$/.test(el.name)) return;
        if (el.type === 'radio' && !el.checked) return;
        var name = el.getAttribute('aria-label') || '';
        if (!name) {
          var fs = el.closest('fieldset');
          var lg = fs ? fs.querySelector('legend') : null;
          name = lg ? lg.textContent : '';
        }
        var wert = '';
        var knopf = el.value ? document.querySelector('.combo-box__option-item[value="' + el.value + '"]') : null;
        if (knopf) wert = knopf.textContent;
        else if (el.id) {
          var lab = document.querySelector('label[for="' + el.id + '"]');
          if (lab) wert = lab.textContent;
        }
        aus.push({
          name: String(name).replace(/\s+/g, ' ').trim(),
          wert: String(wert || el.value || '').replace(/\s+/g, ' ').trim()
        });
      });
      return aus;
    }
    function menge() {
      var f = kaufformular();
      var feld = null;
      if (f && f.id) feld = document.querySelector('input[name="quantity"][form="' + f.id + '"]');
      if (!feld) feld = document.querySelector('.product-form__quantity input[name="quantity"]');
      var n = feld ? parseInt(feld.value, 10) : 1;
      if (!n || n < 1) n = 1;
      return n;
    }

    // Lieferzonen-Rechner (RX 2.0): Zustand liegt am window, weil Focal die Kaufbox
    // beim Variantenwechsel neu aufbaut. Ohne ermittelte Zone ist der Warenkorb gesperrt -
    // das Angebot ebenso, sonst fehlt der Kran-Zuschlag im Preis.
    function rechner() {
      return document.querySelector('[data-lieferzone-rechner]');
    }
    function zone() {
      var Z = window.__lieferzoneZustand;
      return (Z && Z['p' + CTX.productId]) || null;
    }
    function lieferortGesperrt() {
      if (!rechner()) return false;
      var z = zone();
      return !z || !!z.gesperrt;
    }
    function lieferort() {
      var z = zone();
      if (!rechner() || !z || z.abholung || !z.plz || !z.zone) return '';
      return ((z.land || 'DE') + ' ' + String(z.plz).trim().toUpperCase()).replace(/\s+/g, ' ');
    }

    // Ausverkauft: kein Angebot. Verfuegbarkeit der gewaehlten Variante aus der Tabelle.
    function verfuegbarkeitNachziehen() {
      var v = VARIANTEN[varianteId()];
      var ok = !v || v.verfuegbar !== false;
      if (root.hidden === ok) root.hidden = !ok;
    }

    function uebersichtHtml(vid, q) {
      var v = VARIANTEN[vid] || {};
      var z = [];
      z.push('Produkt: ' + CTX.productTitle);
      if (!vid) {
        var opt = optionen().map(function (o) { return o.wert; }).filter(Boolean).join(' / ');
        if (opt) z.push('Ausführung: ' + opt + ' (keine Standardvariante)');
        var lo0 = lieferort();
        if (lo0) z.push('Lieferort: ' + lo0);
        return z.map(esc).join('<br>') + '<br><br><strong>' + esc(q + ' Stück') + '</strong>';
      }
      if (v.titel && v.titel !== 'Default Title') z.push('Ausführung: ' + v.titel);
      if (v.sku) z.push('Artikelnummer: ' + v.sku);
      if (CTX.lieferzeit) z.push('Lieferzeit: ' + CTX.lieferzeit);
      var lo = lieferort();
      if (lo) z.push('Lieferort: ' + lo + ' – Kran-Entladung und Positionierung enthalten');
      var fuss = q + ' Stück';
      if (geld && typeof v.preis === 'number') {
        fuss += ' · ' + geld.format((v.preis * q) / 100) + (CTX.taxesIncluded ? ' inkl. MwSt.' : ' zzgl. MwSt.');
      }
      return z.map(esc).join('<br>') + '<br><br><strong>' + esc(fuss) + '</strong>';
    }

    function fokussierbare() {
      return modal.querySelectorAll('button:not([disabled]),a[href],input:not([type="hidden"]),select,textarea');
    }
    function beiTaste(e) {
      if (e.key === 'Escape') { schliessen(); return; }
      if (e.key !== 'Tab') return;
      var f = fokussierbare(); if (!f.length) return;
      var erstes = f[0], letztes = f[f.length - 1];
      if (e.shiftKey && document.activeElement === erstes) { e.preventDefault(); letztes.focus(); }
      else if (!e.shiftKey && document.activeElement === letztes) { e.preventDefault(); erstes.focus(); }
    }

    function oeffnen() {
      if (hinweis) { hinweis.hidden = true; hinweis.textContent = ''; }
      if (lieferortGesperrt()) {
        if (hinweis) {
          hinweis.textContent = 'Bitte geben Sie oben Ihre Postleitzahl ein oder wählen Sie Selbstabholung – sonst können wir Kran-Entladung und Positionierung nicht ins Angebot aufnehmen.';
          hinweis.className = 'km-msg is-err';
          hinweis.hidden = false;
        }
        var r = rechner();
        if (r) {
          r.classList.add('lz-mahnung');
          setTimeout(function () { r.classList.remove('lz-mahnung'); }, 2000);
          r.scrollIntoView({ behavior: 'smooth', block: 'center' });
          var plz = r.querySelector('[data-lz-plz]');
          if (plz && !plz.disabled) plz.focus();
        }
        return;
      }
      var vid0 = varianteId();
      zusammenfassung.innerHTML = uebersichtHtml(vid0, menge());
      if (lead) {
        lead.textContent = vid0 ? leadText
          : 'Diese Ausführung haben wir nicht als Standard hinterlegt. Schicken Sie uns die Anfrage, wir prüfen Maße und Ausführung und melden uns per E-Mail.';
      }
      if (fertigTitel) fertigTitel.textContent = fertigTitel0;
      if (fertigText) fertigText.textContent = fertigText0;

      // Land aus dem Shopify-Markt vorbelegen, wenn es freigegeben ist
      if (CTX.country) {
        var landFeld = anfrage.elements['land'];
        for (var i = 0; i < landFeld.options.length; i++) {
          if (landFeld.options[i].value === CTX.country) { landFeld.value = CTX.country; break; }
        }
      }

      ustidSichtbarkeit();

      anfrage.hidden = false;
      fertig.hidden = true;
      fehlerfeld.hidden = true;
      modal.hidden = false;
      document.body.classList.add('km-modal-open');
      document.addEventListener('keydown', beiTaste);
      geoeffnetUm = Date.now();
      zuletztFokussiert = document.activeElement;
      var erstesFeld = anfrage.querySelector('input[name="vorname"]');
      if (erstesFeld) erstesFeld.focus();
    }

    function schliessen() {
      modal.hidden = true;
      document.body.classList.remove('km-modal-open');
      document.removeEventListener('keydown', beiTaste);
      if (zuletztFokussiert && zuletztFokussiert.focus) zuletztFokussiert.focus();
    }

    function fehler(text) {
      fehlerfeld.textContent = text;
      fehlerfeld.hidden = false;
      fehlerfeld.scrollIntoView({ block: 'nearest' });
    }

    function adresse() {
      var fehlend = [];
      ['vorname', 'nachname', 'strasse', 'plz', 'ort', 'email'].forEach(function (n) {
        var el = anfrage.elements[n];
        var leer = !String(el.value || '').trim();
        el.setAttribute('aria-invalid', leer ? 'true' : 'false');
        if (leer) fehlend.push(n);
      });
      if (fehlend.length) {
        fehler('Bitte füllen Sie alle Pflichtfelder aus.');
        anfrage.elements[fehlend[0]].focus();
        return null;
      }

      var mail = String(anfrage.elements['email'].value).trim();
      if (!/^[^@\s]+@[^@\s]+\.[a-z]{2,}$/i.test(mail)) {
        anfrage.elements['email'].setAttribute('aria-invalid', 'true');
        fehler('Diese E-Mail-Adresse sieht nicht richtig aus. Ohne sie können wir Ihnen das Angebot nicht schicken.');
        anfrage.elements['email'].focus();
        return null;
      }
      if (!anfrage.elements['dsgvo'].checked) {
        fehler('Bitte bestätigen Sie die Datenschutzerklärung.');
        anfrage.elements['dsgvo'].focus();
        return null;
      }

      function t(n) { return String(anfrage.elements[n].value || '').trim(); }
      return {
        firma: t('firma'), ustid: t('ustid').toUpperCase().replace(/[\s.\-]/g, ''), anrede: t('anrede'),
        vorname: t('vorname'), nachname: t('nachname'),
        strasse: t('strasse'), plz: t('plz'), ort: t('ort'),
        land: t('land') || 'DE', email: mail,
        telefon: t('telefon'), bemerkung: t('bemerkung')
      };
    }

    // Abweichende Lieferanschrift: nur pruefen, wenn der Haken gesetzt ist.
    function lieferanschrift() {
      var an = anfrage.elements['abw_lieferung'];
      if (!an || !an.checked) return { ok: true, wert: null };

      var fehlend = [];
      ['l_person', 'l_telefon', 'l_strasse', 'l_plz', 'l_ort'].forEach(function (n) {
        var el = anfrage.elements[n];
        if (!el) return;
        var leer = !String(el.value || '').trim();
        el.setAttribute('aria-invalid', leer ? 'true' : 'false');
        if (leer) fehlend.push(n);
      });
      if (fehlend.length) {
        fehler('Bitte füllen Sie die Lieferanschrift vollständig aus. Ansprechpartner und Telefon brauchen wir für die Avisierung durch die Spedition.');
        anfrage.elements[fehlend[0]].focus();
        return { ok: false, wert: null };
      }

      function lt(n) {
        var el = anfrage.elements[n];
        return el ? String(el.value || '').trim() : '';
      }
      return {
        ok: true,
        wert: {
          firma: lt('l_firma'),
          person: lt('l_person'),
          telefon: lt('l_telefon'),
          strasse: lt('l_strasse'),
          plz: lt('l_plz'),
          ort: lt('l_ort'),
          land: lt('l_land') || 'DE'
        }
      };
    }

    var abwFeld = anfrage.elements['abw_lieferung'];
    if (abwFeld && lieferBlock) {
      abwFeld.addEventListener('change', function () {
        lieferBlock.hidden = !abwFeld.checked;
        if (!abwFeld.checked) {
          ['l_firma', 'l_person', 'l_telefon', 'l_strasse', 'l_plz', 'l_ort'].forEach(function (n) {
            var el = anfrage.elements[n];
            if (el) { el.value = ''; el.setAttribute('aria-invalid', 'false'); }
          });
        } else {
          var erstes = anfrage.elements['l_person'];
          if (erstes) erstes.focus();
        }
      });
    }

    knopf.addEventListener('click', oeffnen);

    // Variantenwechsel: Focal tauscht Teile der Kaufbox aus, ohne ein Ereignis nach aussen
    // zu geben. Der Beobachter zieht die Verfuegbarkeit nach (entprellt).
    verfuegbarkeitNachziehen();
    var anstehend = null;
    new MutationObserver(function () {
      clearTimeout(anstehend);
      anstehend = setTimeout(verfuegbarkeitNachziehen, 80);
    }).observe(document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['value', 'disabled'] });
    document.addEventListener('change', function (e) {
      if (e.target && e.target.name && /^(id|option\d)$/.test(e.target.name)) setTimeout(verfuegbarkeitNachziehen, 50);
    }, true);
    modal.querySelectorAll('[data-km-close]').forEach(function (b) {
      b.addEventListener('click', schliessen);
    });

    // USt-IdNr. nur fuer Firmenkunden aus dem EU-Ausland.
    function ustidSichtbarkeit() {
      var feld = anfrage.querySelector('.km-fld--ustid');
      var landFeld = anfrage.elements['land'];
      if (!feld || !landFeld) return;
      var auslaendisch = landFeld.value && landFeld.value !== 'DE';
      feld.hidden = !auslaendisch;
      if (!auslaendisch && anfrage.elements['ustid']) anfrage.elements['ustid'].value = '';
    }
    if (anfrage.elements['land']) anfrage.elements['land'].addEventListener('change', ustidSichtbarkeit);

    anfrage.addEventListener('submit', function (e) {
      e.preventDefault();
      if (laeuft) return;
      fehlerfeld.hidden = true;

      var kunde = adresse();
      if (!kunde) return;

      var liefer = lieferanschrift();
      if (!liefer.ok) return;

      if (!CTX.quoteEndpoint) {
        fehler('Die Anfrage kann gerade nicht übermittelt werden. Bitte rufen Sie uns an: +49 9672 9269 110');
        return;
      }

      var absenden = anfrage.querySelector('button[type="submit"]');
      laeuft = true;
      absenden.setAttribute('aria-busy', 'true');

      var vid = varianteId();
      var v = VARIANTEN[vid] || {};

      var nutzlast = {
        typ: 'produkt',
        produkt_id: String(CTX.productId || ''),
        produkt_titel: CTX.productTitle,
        produkt_url: CTX.productUrl || '',
        variante_id: vid,
        variante_titel: v.titel || '',
        sku: v.sku || CTX.sku || '',
        menge: menge(),
        lieferort: lieferort(),
        hp: String(anfrage.elements['hp'].value || ''),
        ms: Date.now() - geoeffnetUm,
        dsgvo: true,
        kunde: kunde,
        lieferung: liefer.wert
      };
      if (!vid) nutzlast.optionen = optionen();

      fetch(CTX.quoteEndpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(nutzlast)
      })
        .then(function (res) {
          return res.json().catch(function () { return {}; }).then(function (j) { return { ok: res.ok, body: j }; });
        })
        .then(function (a) {
          if (!a.ok || a.body.ok !== true) throw new Error(a.body && a.body.grund ? a.body.grund : '');
          if (a.body.manuell === true) {
            if (fertigTitel) fertigTitel.textContent = 'Ihre Anfrage ist bei uns';
            if (fertigText) fertigText.textContent = 'Diese Ausführung prüfen wir von Hand und melden uns per E-Mail bei Ihnen. Schauen Sie bitte auch im Spam-Ordner nach.';
          }
          anfrage.hidden = true;
          fertig.hidden = false;
          fertig.querySelector('button').focus();
        })
        .catch(function (e) {
          fehler((e.message ? e.message + ' ' : 'Die Anfrage konnte nicht übermittelt werden. ') +
            'Bitte versuchen Sie es noch einmal oder rufen Sie uns an: +49 9672 9269 110');
        })
        .then(function () {
          laeuft = false;
          absenden.removeAttribute('aria-busy');
        });
    });
  }

  document.querySelectorAll('.km-angebot[data-section-id]').forEach(init);
})();
